// Theme-only presentation. Upload-Lift owns its controls, file lifecycle and properties.
(() => {
  const normalize = value => value.toLowerCase().replace(/[^a-z]/g, '');
  function scan() {
    for (const details of document.querySelectorAll('.product-details[data-personalization-mode]:not([data-personalization-mode="none"])')) {
      const instructions=details.querySelector('[data-personalized-upload-instructions]');
      if(!instructions)continue;
      const labels=details.querySelectorAll('[data-upload-lift] .cl-upload--label');
      for(const label of labels) {
        // Only the known duplicate static title; errors, help, limits and live regions stay visible.
        if(['uploadyourpetphotos','uploadyourpetphoto'].includes(normalize(label.textContent)))label.classList.add('photo-upload-duplicate-label');
      }
      const uploader=details.querySelector('[data-upload-lift]');
      if(uploader)uploader.closest('.shopify-app-block')?.classList.add('photo-upload-app');
    }
  }
  let scheduled=false;
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;scan();});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true});
})();
